const useFormFactoryLogic = ({
  submitFun,
  errors,
}: {
  submitFun: (values: any, formType?: "sale" | "form") => void;
  errors: any;
}) => {
  const onSubmit = (data: any) => {
    if (Object.keys(errors).length === 0) {
      submitFun(data, "form");
    }
  };

const hasCommentTitle = (formFields: any): boolean => {
  return formFields?.fields?.some(
    (item: any) => item.field?.key?.toLowerCase() === "comment"
  );
};


  return { onSubmit, hasCommentTitle };
};

export default useFormFactoryLogic;
